import React, { FC } from "react";
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import { getInstructionDisplay, camelCaseToText } from '../../../../../constants/InstructionLabels';
import { SequenceReferenceTreeNodeLabel, TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { ConditionInstruction } from '../../../../../machinelogic/types';
import { InstructionStateStatus, SequenceState } from "../../../../../machinelogic/constants";
import { ExecuteType } from "../../../../../machinelogic/instruction_types/ConditionTypes";

const executeLabel = {
  [ExecuteType.IN_SERIES]: 'in Series',
  [ExecuteType.IN_PARALLEL]: 'in Parallel'
};

interface ConditionInstructionProps extends InstructionNodeProps {
  instruction: ConditionInstruction;
}

export const ConditionNode: FC<ConditionInstructionProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const instructionDisplay = getInstructionDisplay(instruction);

  const instructionLabel = <TreeNodeLabel
    icon={instructionDisplay.icon}
    name={instructionDisplay.name}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode
      title={instructionLabel}
      isCollapsible
      isDefaultExpanded={true}
    >
      {instruction.parameters.conditions.map((condition, index) => {
        const { conditionExpression, execute, instructionType, sequenceName } = condition;
        const statementString = `${camelCaseToText(instructionType)} ${conditionExpression}`;
        const executionString = `execute ${sequenceName} ${executeLabel[execute]}`;
        const activeSequence = instruction.state.subInstructionState?.activeSequence === sequenceName;

        return (
          <TreeNode key={conditionExpression + index} title={<TreeNodeLabel name={statementString} onClick={onClick} />}>
            <TreeNode
              title={
                <SequenceReferenceTreeNodeLabel
                  name={executionString}
                  onClick={onClick}
                  sequenceName={sequenceName}
                />
              }
              titleClassName={ cx({
                'ml_animated_background_tree running': activeSequence && instruction.state.status === InstructionStateStatus.RUNNING,
                'ml_animated_background_tree waiting': activeSequence && instruction.state.status === InstructionStateStatus.WAITING,
                'ml_animated_background_tree paused': activeSequence && instruction.state.status === InstructionStateStatus.PAUSED
              }) }
            />
          </TreeNode>
        );
      })}
    </TreeNode>
  );
});